import React from 'react';
import SubNavbar from './SubNavbar';
import Navbar from './Navbar';

function AllComponents() {
  return (
    <div>
      <SubNavbar />
      <Navbar />
    </div>
  );
}

export default AllComponents;
